import { Refund } from '@spike/payments-model';
import { FunctionComponent } from 'react';
import Transaction from './Transaction';

interface TransactionProps {
    refund: Refund;
}

export const RefundTransaction: FunctionComponent<TransactionProps> = props => (
    <Transaction
        paymentMethodId={props.refund.payment.paymentMethod.id}
        paymentMethodName={props.refund.payment.paymentMethod.name}
        cardDigits={props.refund.payment.cardDigits || ''}
        amount={props.refund.amount}
        date={props.refund.refundDate}
        status={props.refund.status}
        type=""
        isRefund={true}
    />
);

export default RefundTransaction;
